import Vue from 'vue';
import ToolBar from '../../parts/ToolBar.vue';
import WalletBar from '../../parts/WalletBar.vue';
export default Vue.extend({
    components: { ToolBar, WalletBar },
    name: "DonationTop"
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/donation/DonationTop.vue
// module id = 658
// module chunks = 1